const MOBILE_RELEASE = require('./mobileRelease.json');
const PUBLIC_IDENTITY = require('./publicIdentity.json');

// Fail closed: a draft or invalid URL must never become a download button.
function getStoreUrl(platform, release) {
  if (!['released', 'beta'].includes(release?.status) || typeof release.url !== 'string') return null;
  try {
    const url = new URL(release.url);
    if (url.protocol !== 'https:' || url.username || url.password || url.port || url.hash) return null;
    if (release.status === 'beta') {
      return platform === 'android' && release.distribution === 'apk'
        && Number.isSafeInteger(release.versionCode) && release.versionCode > 0
        && url.hostname === 'noesa.ai' && !url.search
        && url.pathname === `/downloads/android/noesa-android-${release.versionCode}.apk`
        ? url.href : null;
    }
    if (platform === 'ios' && url.hostname === 'apps.apple.com'
      && /^\/(?:[a-z]{2}\/)?app\/(?:[^/]+\/)?id\d+\/?$/.test(url.pathname)) return url.href;
    if (platform === 'android' && release.distribution === 'rustore'
      && url.hostname === 'www.rustore.ru' && !url.search
      && url.pathname === '/catalog/app/ai.noesa.mobile.direct') return url.href;
    if (platform === 'android' && url.hostname === 'play.google.com'
      && url.pathname === '/store/apps/details'
      && url.searchParams.getAll('id').length === 1
      && url.searchParams.get('id') === 'ai.noesa.mobile') return url.href;
  } catch { /* Keep the prelaunch state for malformed URLs. */ }
  return null;
}

function getMobileContent(language = 'ru', releases = MOBILE_RELEASE.stores) {
  const locale = language === 'en' ? 'en' : 'ru';
  const copy = MOBILE_RELEASE.locales[locale];
  const stores = ['ios', 'android'].map((platform) => {
    const release = releases[platform];
    const primary = release?.store || release;
    const href = getStoreUrl(platform, primary);
    const directBeta = Boolean(href && platform === 'android' && primary?.status === 'beta');
    const rustore = Boolean(href && platform === 'android' && primary?.distribution === 'rustore');
    const fallbackHref = rustore ? getStoreUrl(platform, release) : null;
    return {
      platform, href,
      name: platform === 'ios' ? 'App Store' : rustore ? 'RuStore' : directBeta ? 'Android' : 'Google Play',
      directBeta, rustore,
      fallbackHref,
      fallbackDownloadName: fallbackHref ? `noesa-android-${release.versionCode}.apk` : null,
      downloadName: directBeta ? `noesa-android-${releases[platform].versionCode}.apk` : null,
      version: directBeta || rustore ? release.version : null,
      device: platform === 'ios' ? copy.iosDevice : copy.androidDevice,
      status: directBeta ? 'beta' : href ? 'released' : 'coming_soon',
      label: directBeta ? copy.androidBetaLabel : href ? copy.storeCta : copy.comingSoon,
      downloadLabel: rustore ? copy.rustoreDownloadLabel : directBeta ? copy.androidDownloadLabel : null,
      downloadEyebrow: rustore ? copy.rustoreDownloadEyebrow : directBeta ? copy.androidDownloadEyebrow : null,
      betaNote: rustore ? copy.androidDevice : directBeta ? copy.androidBetaNote : null,
      badgeSrc: platform === 'ios' ? `/assets/stores/app-store-${locale}.svg` : null,
      badgeLabel: platform === 'ios' ? copy.appStoreLabel : null,
    };
  });
  const anyReleased = stores.some((store) => store.href);
  return {
    ...copy, stores,
    h1: anyReleased ? copy.h1Available : copy.h1Prelaunch,
    releaseNote: anyReleased ? copy.availableNote : copy.prelaunchNote,
    teaserTitle: anyReleased ? copy.teaserAvailableTitle : copy.teaserPrelaunchTitle,
    updatesUrl: PUBLIC_IDENTITY.socials.telegram,
    supportUrl: `https://api.noesa.ai/legal/mobile/support?lang=${locale}`,
    privacyUrl: `https://api.noesa.ai/legal/mobile/privacy?lang=${locale}`,
    // The route exists in the backend source but is not deployed yet (HTTP 404).
    deletionUrl: MOBILE_RELEASE.accountDeletionPageReady
      ? `https://api.noesa.ai/legal/mobile/account-deletion?lang=${locale}` : null,
  };
}

module.exports = { getStoreUrl, getMobileContent };
